import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import InputField from "../../../../common/InputField"
import ReactSelect from '@common/ReactSelect';
import { APP_TYPE_AGENCY, COND_SHOW_FIELDS_ACC_INSURERS, COUNTRY_CODE, FEATURE_LISTING, INS_TYPE_CTPL,VEHICLE_TYPE_MOTORCYCLE,VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL,INSURER_EXCLUDE_ID } from '@src/config/constant';
import { useDispatch } from 'react-redux';
import { getMMVList,getBrandList,getParentModelList,getVersionList,setNewMMVlist } from '@src/store/slices/common';
import { useLanguage } from '@src/context/LanguageContext';
import {FUEL_TYPE_MAPPING, VEHICLE_CATEGORY, VEHICLE_TYPE } from '@src/config/id/constant';

const isCountryId = COUNTRY_CODE === 'id'?true:false

export default function VehicleDetailsForm(props: any): ReturnType<React.FC> {
    const commonState = useSelector((state: any) => state.common);
    const insuranceState = useSelector((state: any) => state.insurance)
    const { application_type_id } = insuranceState?.leadDetail || {}
    const {translations} = useLanguage();

    const dispatch: any = useDispatch()

    const changeHandler = (value: any, key: string) => {
        if (COUNTRY_CODE === 'id') {
            return changeHandlerForID(value, key)
        }

        let formFields: object = props.vehicleDetails;
        if (["fuel_type", "seat_capacity", "transmission"].includes(key)) {
            formFields = { ...formFields, [key]: value.value }
        } else {
            formFields = { ...formFields, [key]: value.target.value }
        }
        props.changeHandler(formFields, "vehicle-details");
    }

    const fetchMMV = async (params: any) => {
        let { usage_type, vehicle_type, category_id } = params

        if (usage_type) {
            let vehicle_usage = usage_type
            let params = { vehicle_usage, vehicle_type, category_id }
            if (!(commonState?.mmvList?.[params['category_id']] && Object?.keys(commonState?.mmvList?.[params['category_id']])?.length)) {
                props.setLoading(true)
                await dispatch(getMMVList(params))
                props.setLoading(false)
                return

            } else {
                return //commonState?.mmvList?.[params['category_id']] || []
            }
        }
    }
    

    const changeHandlerForID = (value: any, key: string) => {
        let formFields: object = props.vehicleDetails;
        if (["fuel_type", "seat_capacity", "transmission", 'vehicle_type', 'make', 'model', 'version', 'make_year', 'plate_area','master_type','vehicle_category'].includes(key)) {
            let editedFields: any = {}
            if (['make', 'model', 'version'].includes(key)) {
                let dependencyObj: any = { make: ['model', 'version'], model: ['version'] }

                //clear make model version
                Object.keys(dependencyObj)?.forEach((field: any) => {
                    if (field === key) {
                        dependencyObj[field]?.forEach((ele: any) => {
                            editedFields[ele] = null
                            editedFields[ele + "_name"] = null
                        })
                    }
                })

                if(isCountryId){
                    fetchV2MMV({ vehicle_type: vehicleDetails?.vehicle_type, [key]: value.value},'change')
                    if(key==='model'){
                       formFields = { ...formFields, ...editedFields, 'parent_model_id': value.value, 'parent_model_name': value.label, 'model_name': value.label }
                    }
                    else if(key==='version'){
                       formFields = { ...formFields, ...editedFields, 'version': value.value, 'version_name': value.label,'model':value.model,'model_name':value.model_name, 'engine_capacity': value?.engine_capacity || null }
                    }
                    else{
                      formFields = { ...formFields, ...editedFields, [key]: value.value, [key + "_name"]: value.label }
                    }
                }else{
                    formFields = { ...formFields, ...editedFields, [key]: value.value, [key + "_name"]: value.label }
                }

            } 
            else {
                if (key === 'vehicle_type') {
                    if(isCountryId){
                        formFields = { ...formFields, 'make': null, 'model': null, 'version': null, 'make_name': null, 'model_name': null, 'version_name': null,"parent_model_id":null }
                        fetchV2MMV({ category_id: value.category_id,vehicle_type: value.value},'change')
                        dispatch(setNewMMVlist({model:[],version:[]}));
                    }else{
                        fetchMMV({ usage_type: insuranceState?.leadDetail?.usage_type, vehicle_type: value.value, category_id: value.category_id })
                    }
                }

                else if (key === 'plate_area') {
                    formFields = { ...formFields, 'plate_number_region': value?.region || '' }
                }
                else if(key === 'vehicle_category' && isCountryId){
                    dispatch(setNewMMVlist({make:[],model:[],version:[]}));
                    const newValue = value.value
                    if(newValue===VEHICLE_CATEGORY.BUS_TRUCK_PICKUP){
                        const options = commonState?.common?.vehicle_type?.filter((e: any) => +e.category_id === newValue);
                        const truckValue = options?.[0]?.value;
                        fetchV2MMV({ category_id: newValue,vehicle_type: truckValue},'change')
                        formFields = { ...formFields, 'make': null, 'model': null, 'version': null, 'make_name': null, 'model_name': null, 'version_name': null,"vehicle_type":truckValue,"parent_model_id":null }
                    }else{
                        formFields = { ...formFields, 'make': null, 'model': null, 'version': null, 'make_name': null, 'model_name': null, 'version_name': null,'vehicle_type':null,"parent_model_id":null }
                    }
                }

                formFields = { ...formFields, [key]: value.value }
            }
        } 
        else if (["machine_number", "chassis_number", "color"].includes(key)) {
            const inputValue = value.target.value;
            const formattedValue = inputValue.toUpperCase();
            formFields = { ...formFields, [key]: formattedValue }
        } 
        else if (key === 'plate_no') {
            const currentFields: any = formFields || {};
            const plateAreaItem = commonState?.common?.plate_area?.find((e: any) => Number(currentFields?.plate_area) === +e.value);
            const plateAreaLabel = String(plateAreaItem?.label || plateAreaItem?.name || '').trim().toUpperCase();
            const plateAreaPrefix = plateAreaLabel ? plateAreaLabel.split('-')[0].trim().split(/\s+/)[0] : '';
            const existingPrefix = String(currentFields?.plate_no || '').trim().toUpperCase().match(/[A-Z]{1,3}/)?.[0] || '';
            const platePrefix = plateAreaPrefix || existingPrefix;
            if (platePrefix) {
                const normalized = String(value?.target?.value ?? '').toUpperCase().replace(/\s+/g, '');
                let suffix = '';

                if (normalized.startsWith(platePrefix)) {
                    suffix = normalized.slice(platePrefix.length);
                } else if (normalized.length < platePrefix.length) {
                    suffix = '';
                } else {
                    suffix = normalized;
                }

                formFields = { ...formFields, [key]: suffix ? `${platePrefix}${suffix}` : platePrefix };
            } else {
                formFields = { ...formFields, [key]: String(value?.target?.value ?? '').toUpperCase().replace(/\s+/g, '') }
            }
        }
        else {
            formFields = { ...formFields, [key]: value.target.value }
        }

        props.changeHandler(formFields, "vehicle-details");

    }

    const getFieldOptions = (fieldItemName: string) => {
        switch (fieldItemName) {
            case 'make':
            case 'model':
            case 'version': {
                let categoryId = commonState?.common?.vehicle_type?.find((e: any) => +e.value === +vehicleDetails?.vehicle_type)?.category_id
                let options = commonState?.mmvList?.[categoryId]?.[fieldItemName]
                if(isCountryId){
                    options = commonState?.newMMVlist?.[fieldItemName]
                }

                if(!isCountryId){
                    if (fieldItemName === 'model') {
                        options = options?.filter((e: any) => +e.make === +vehicleDetails?.make)
                    } else if (fieldItemName === 'version') {
                        options = options?.filter((e: any) => +e.model === +vehicleDetails?.model)
                    }
                }


                return options
            }
            case 'vehicle_type': {
                let options = commonState?.common?.vehicle_type
                if(isCountryId){
                    options = commonState?.common?.vehicle_type?.filter((e: any) => +e.category_id === +vehicleDetails?.vehicle_category)
                }
                return options
                
            }

            default: {
                return []
            }
        }
    }

    const getOptionLabel = (option: any) => option?.label || option?.name || '';

    const loadData = () => {
        let mmvParams = {
            usage_type: insuranceState?.leadDetail?.usage_type,
            vehicle_type: vehicleDetails?.vehicle_type,
            category_id: commonState?.common?.vehicle_type?.find((e: any) => e.value === vehicleDetails?.vehicle_type)?.category_id
        }

        if(isCountryId){  
            fetchV2MMV()
        }else{
            fetchMMV(mmvParams)
        }

        let { make_name, model_name, version_name } = insuranceState?.leadDetail
        props.changeHandler({ ...props.vehicleDetails, make_name, model_name, version_name }, "vehicle-details");
    }

    const fetchV2MMV = async (params: any={},callType='init') => {

       const category_id = params?.category_id? params?.category_id : commonState?.common?.vehicle_type?.find((e: any) => e.value === vehicleDetails?.vehicle_type)?.category_id
        props.setLoading(true)
        if(callType==='init' && commonState.newMMVlist.lead_id!==insuranceState?.leadDetail?.id){
            const vehicle_type = vehicleDetails?.vehicle_type
            let brandPayload:Record<string,any> = {category_id}
            if(vehicle_type === VEHICLE_TYPE.EV) brandPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.EV]
            if(vehicle_type === VEHICLE_TYPE.HYBRID) brandPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.HYBRID]
            await dispatch(getBrandList(brandPayload));
            let modelPayload:Record<string,any> = {category_id ,make: vehicleDetails?.make}
            if(vehicle_type === VEHICLE_TYPE.EV) modelPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.EV]
            if(vehicle_type === VEHICLE_TYPE.HYBRID) modelPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.HYBRID]
            await dispatch(getParentModelList(modelPayload));
            let versionPayload:Record<string,any> = {category_id ,make: vehicleDetails?.make,model: vehicleDetails?.parent_model_id || vehicleDetails?.model}
            if(vehicle_type === VEHICLE_TYPE.EV) versionPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.EV]
            if(vehicle_type === VEHICLE_TYPE.HYBRID) versionPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.HYBRID]
            await dispatch(getVersionList(versionPayload));
            dispatch(setNewMMVlist({lead_id:insuranceState?.leadDetail?.id}))
        }else{
            const isBrandListRecalled =   vehicleDetails.vehicle_type!==params.vehicle_type 
            const isModelListRecalled =   vehicleDetails.make!==params.make
            const isVersionListRecalled = vehicleDetails.parent_model_id!==params.model
            let brandPayload:Record<string,any> = {category_id}
            if(params.vehicle_type === VEHICLE_TYPE.EV) brandPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.EV]
            if(params.vehicle_type === VEHICLE_TYPE.HYBRID) brandPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.HYBRID]
            if(isBrandListRecalled && params.category_id) await dispatch(getBrandList(brandPayload));
            const make = params?.make? params?.make : vehicleDetails?.make
            let modelPayload:Record<string,any> = {category_id,make}
            if(params.vehicle_type === VEHICLE_TYPE.EV) modelPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.EV]
            if(params.vehicle_type === VEHICLE_TYPE.HYBRID) modelPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.HYBRID]
            if(isModelListRecalled && params?.make) await dispatch(getParentModelList(modelPayload));
            const model = params?.model? params?.model : vehicleDetails?.parent_model_id
            let versionPayload:Record<string,any> = {category_id,make,model}
            if(params.vehicle_type === VEHICLE_TYPE.EV) versionPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.EV]
            if(params.vehicle_type === VEHICLE_TYPE.HYBRID) versionPayload['fuel_type'] = FUEL_TYPE_MAPPING[VEHICLE_TYPE.HYBRID]
            if(isVersionListRecalled && params?.model) await dispatch(getVersionList(versionPayload));
        }
        props.setLoading(false) 
    }

    let { vehicleDetails, errors, changeHandler: onVehicleDetailsChange } = props;
    const normalizedPlateNo = isCountryId ? String(vehicleDetails?.plate_no || '').toUpperCase().replace(/\s+/g, '') : String(vehicleDetails?.plate_no || '');

    let fieldMapping: any = {

        VEHICLE_CATEGORY: (
            <ReactSelect
                options={commonState?.common.vehicle_category}
                value={commonState?.common?.vehicle_category?.find((v: any) => Number(vehicleDetails?.vehicle_category) === +v.value) || null}
                placeholder={`${translations.Insurance?.VEHICLE_CATEGORY || translations.commonMsg?.loading} *`}
                isDisabled={COUNTRY_CODE === 'id' ? true : props.disable}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                fieldKey={'vehicle_category'}
                fieldSetClassName="col-md-6"
                errorField={errors?.['vehicle_category']} />
        ),

        VEHICLE_TYPE: (
            <ReactSelect
                options={getFieldOptions('vehicle_type')}
                value={getFieldOptions('vehicle_type')?.find((v: any) => Number(vehicleDetails?.vehicle_type) === +v.value) || null}
                placeholder={`${translations.Insurance?.['Vehicle Type'] || translations.commonMsg?.loading} *`}
                 isDisabled={COUNTRY_CODE === 'id' ? true : props.disable}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                fieldKey={'vehicle_type'}
                fieldSetClassName="col-md-6"
                errorField={errors?.['vehicle_type']} />
        ),



        PLATE_AREA: (
            <ReactSelect
                options={commonState?.common.plate_area || []}
                value={
                    (commonState?.common?.plate_area &&
                        commonState.common.plate_area.find((v: any) => Number(vehicleDetails?.plate_area) === +v.value)) || null
                }
                placeholder={`${translations.Insurance?.['Plate Area'] || translations.commonMsg?.loading} *`}
                isDisabled={COUNTRY_CODE === 'id' ? true : props.disable}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                fieldKey={'plate_area'}
                fieldSetClassName="col-md-6"
                errorField={errors?.['plate_area']} />
        ),

        PLATE_NUMBER_REGION: (
            <fieldset className="col-md-6">
                <div className="material" title={vehicleDetails?.plate_number_region}>
                    <InputField
                        inputProps={{
                            id: "plate_number_region",
                            name: "plate_number_region",
                            className: "form-input",
                            type: "text",
                            // value: commonState?.common?.plate_area.find((v: any) => Number(vehicleDetails?.plate_area) === +v.value)?.region || '',
                            value: (commonState?.common?.plate_area?.find((v: any) => Number(vehicleDetails?.plate_area) === +v.value)?.region) || '',
                            maxLength: '',
                            disabled: true,
                            placeholder: " "
                        }}
                        onChange={(e: any) => changeHandler(e, 'plate_number_region')}
                    />
                    <label data-label={`${translations.Insurance?.['Plate Number Region'] || translations.commonMsg?.loading} *`} className="form-label"></label>
                    {
                        errors.plate_number_region ?
                            <span className="error-txt ">{errors.plate_number_region}</span>
                            : ''
                    }
                </div>
            </fieldset>
        ),

        MAKE: (
            <ReactSelect
                options={getFieldOptions('make')}
                value={getFieldOptions('make')?.find((v: any) => Number(vehicleDetails?.make) === +v.value) || null}
                placeholder={`${translations.Insurance?.['Make'] || translations.commonMsg?.loading} *`}
                isDisabled={props.disable}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                fieldKey={'make'}
                fieldSetClassName="col-md-6"
                errorField={errors?.['make']} />
        ),

        MODEL: (
            <ReactSelect
                options={getFieldOptions('model')}
                value={getFieldOptions('model')?.find((v: any) => Number(isCountryId?(vehicleDetails?.parent_model_id || vehicleDetails?.model) :vehicleDetails?.model) === +v.value) || null}
                placeholder={`${translations.Insurance?.['Model'] || translations.commonMsg?.loading} *`}
                isDisabled={props.disable}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                fieldKey={'model'}
                fieldSetClassName="col-md-6"
                errorField={errors?.['model']} />
        ),

        VERSION: (
            <ReactSelect
                options={getFieldOptions('version')}
                value={getFieldOptions('version')?.find((v: any) => Number(vehicleDetails?.version) === +v.value) || null}
                placeholder={`${translations.Insurance?.['Version'] || translations.commonMsg?.loading} *`}
                isDisabled={props.disable}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                fieldKey={'version'}
                fieldSetClassName="col-md-6"
                errorField={errors?.['version']} />
        ),

        ENGINE_CAPACITY: (
            <fieldset className="col-md-6">
                <div className="material" title={vehicleDetails?.engine_capacity}>
                    <InputField
                        inputProps={{
                            id: "engine_capacity",
                            name: "engine_capacity",
                            className: "form-input",
                            type: "number",
                            value: (vehicleDetails?.engine_capacity === "" || vehicleDetails?.engine_capacity === undefined || vehicleDetails?.engine_capacity === null) ? "" : vehicleDetails?.engine_capacity,
                            maxLength: '',
                            disabled: false,
                            placeholder: " "
                        }}
                        
                        onChange={(e: any) => changeHandler(e, 'engine_capacity')}
                    />
                    <label 
                    data-label={`${(isCountryId)?translations.Insurance?.['CUBIC_CAP']:translations.Insurance?.['ENGINE_CAP'] || translations.commonMsg?.loading}`} 
                    className="form-label"
                    ></label>
                    {
                        errors.machine_number ?
                            <span className="error-txt">{errors.engine_capacity}</span>
                            : ''
                    }
                </div>
            </fieldset>
        ),

        MAKE_YEAR: (
            <ReactSelect
                options={commonState?.common?.make_year || []}
                // value={commonState?.common?.make_year.find((v: any) => Number(vehicleDetails?.make_year) === +v.value) || null}
                value={
                    Array.isArray(commonState?.common?.make_year) 
                        ? commonState.common.make_year.find((v: any) => Number(vehicleDetails?.make_year) === +v.value) || null
                        : null
                }
                placeholder={`${translations.Insurance?.['Make Year'] || translations.commonMsg?.loading} *`}
                isDisabled={props.disable}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)}
                fieldKey={'make_year'}
                fieldSetClassName="col-md-6"
                errorField={errors?.['make_year']} />
        ),

        PLATE_NUMBER: (
            <fieldset className="col-md-6">
                <div className="material" title={normalizedPlateNo}>
                    <InputField
                        inputProps={{
                            id: "plate_no",
                            name: "plate_no",
                            className: "form-input",
                            type: "text",
                            value: normalizedPlateNo,
                            maxLength: '',
                            spellCheck: false,
                            disabled: props.disable,
                            placeholder: " "
                        }}
                        onChange={(e: any) => changeHandler(e, 'plate_no')}
                    />
                    <label data-label={(COUNTRY_CODE !== 'id' && props.insuranceType === INS_TYPE_CTPL) ? `${translations.Insurance?.['Plate Number'] || translations.commonMsg?.loading} **` : `${translations.Insurance?.['Plate Number'] || translations.commonMsg?.loading} *`}className="form-label"></label>
                    {
                        errors.plate_no ?
                            <span className="error-txt ">{errors.plate_no}</span>
                            : ''
                    }
                </div>
            </fieldset>
        ),

        MV_NUMBER: (
            (props.insuranceType === INS_TYPE_CTPL) && <fieldset className="form-filed col-md-6">
                <div className="material" title={vehicleDetails?.mv_number}>
                    <InputField
                        inputProps={{
                            id: "mv_number",
                            name: "mv_number",
                            className: "form-input",
                            type: "text",
                            value: vehicleDetails.mv_number || '',
                            maxLength: '',
                            disabled: props.disable,
                            placeholder: " "
                        }}
                        onChange={(e: any) => changeHandler(e, 'mv_number')}
                    />
                    <label data-label="MV File Number **" className="form-label"></label>
                    {
                        errors.mv_number ?
                            <span className="error-txt ">{errors.mv_number}</span>
                            : ''
                    }
                </div>
            </fieldset>
        ),

        MACHINE_NUMBER: (
            <fieldset className="col-md-6">
                <div className="material" title={vehicleDetails?.machine_number}>
                    <InputField
                        inputProps={{
                            id: "machine_number",
                            name: "machine_number",
                            className: "form-input",
                            type: "text",
                            value: vehicleDetails.machine_number || '',
                            maxLength: '',
                            disabled: false,
                            placeholder: " "
                        }}
                        onChange={(e: any) => changeHandler(e, 'machine_number')}
                    />
                    <label data-label={(application_type_id === APP_TYPE_AGENCY || COUNTRY_CODE === 'id') ? `${translations.Insurance?.['Machine Number'] || translations.commonMsg?.loading} *` : `${translations.Insurance?.['Engine Number'] || translations.commonMsg?.loading}`} className="form-label"></label>
                    {
                        errors.machine_number ?
                            <span className="error-txt">{errors.machine_number}</span>
                            : ''
                    }
                </div>
            </fieldset>
        ),

        CHASSIS_NUMBER: (
            <fieldset className="col-md-6">
                <div className="material" title={vehicleDetails?.chassis_number}>
                    <InputField
                        inputProps={{
                            id: "chassis_number",
                            name: "chassis_number",
                            className: "form-input",
                            type: "text",
                            value: vehicleDetails.chassis_number || '',
                            maxLength: '',
                            disabled: false,
                            placeholder: " "

                        }}
                        onChange={(e: any) => changeHandler(e, 'chassis_number')}
                    />
                    <label data-label={`${translations.Insurance?.['Chassis Number'] || translations.commonMsg?.loading}${COUNTRY_CODE === 'id' || application_type_id === APP_TYPE_AGENCY ? ' *' : ''}`} className="form-label"></label>
                    {
                        errors.chassis_number ?
                            <span className="error-txt">{errors.chassis_number}</span>
                            : ''
                    }
                </div>
            </fieldset>
        ),

        COLOR: (
            <fieldset className="col-md-6">
                <div className="material" title={vehicleDetails?.color}>
                    <InputField
                        inputProps={{
                            id: "color",
                            name: "color",
                            className: "form-input",
                            type: "text",
                            value: vehicleDetails.color || '',
                            maxLength: '',
                            disabled: false,
                            placeholder: " "

                        }}
                        onChange={(e: any) => changeHandler(e, 'color')}
                    />
                    <label data-label={`Color${application_type_id === APP_TYPE_AGENCY ? ' *' : ''}`} className="form-label"></label>

                    {
                        errors.color ?
                            <span className="error-txt">{errors.color}</span>
                            : ''
                    }
                </div>
            </fieldset>
        ),

        FUEL_TYPE: (
            <ReactSelect 
                options={commonState?.common?.fuel_type} 
                value={commonState?.common?.fuel_type?.find((v: any) => vehicleDetails?.fuel_type?.toLowerCase() === v?.value?.toLowerCase()) || {}} 
                placeholder={`${translations.Insurance?.['Fuel Type']} ${COUNTRY_CODE !== 'id' ? '*' : ''}` || translations.commonMsg?.loading} 
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="fuel_type" 
                fieldSetClassName="col-md-6" 
                isDisabled={COUNTRY_CODE === 'id' ? true : props.disable} />
        ),

        TRANSMISSION: (
            <ReactSelect options={commonState?.common?.transmission} value={commonState?.common?.transmission?.find((v: any) => vehicleDetails?.transmission?.toLowerCase() === v?.value?.toLowerCase()) || ''} placeholder={translations.Insurance?.['Transmission'] || translations.commonMsg?.loading}handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="transmission" fieldSetClassName="col-md-6" isDisabled={COUNTRY_CODE === 'id' ? true : props.disable} errorField={errors.transmission} />
        ),

        SEATING_CAPACITY: (
            <ReactSelect options={commonState?.common?.seat_capacity} value={commonState?.common?.seat_capacity?.find((v: any) => +vehicleDetails.seat_capacity === +v.value) || {}} placeholder={`${translations.Insurance?.['Seat Capacity'] || translations.commonMsg?.loading} ${application_type_id === APP_TYPE_AGENCY && COUNTRY_CODE !== 'id' ? '*' : ''}`} handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="seat_capacity" fieldSetClassName="col-md-6" isDisabled={COUNTRY_CODE === 'id' ? true : props.disable} />

        )
    }

    const conditionalFieldMapping: any = {
        MASTER_TYPE: (
            <ReactSelect options={commonState?.common?.master_type} value={commonState?.common?.master_type?.find((v: any) => vehicleDetails.master_type === v.value) || {}} placeholder={`${translations.Insurance?.['MASTER_TYPE']}*`} handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="master_type" fieldSetClassName="col-md-6" errorField={errors?.['master_type']} />
        )
    }
    
    if (insuranceState?.leadDetail?.insurer_id && COND_SHOW_FIELDS_ACC_INSURERS.includes(insuranceState.leadDetail.insurer_id)
    ) {
        fieldMapping = {
            ...fieldMapping,
            ...conditionalFieldMapping
        }
    }

    const visibleFields = Object.keys(fieldMapping)?.filter((field: any) => FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS']['VEHICLE_DETAILS'][field])
    

    useEffect(() => {
        if (COUNTRY_CODE === 'id') {
            loadData()
        }
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (!isCountryId || !Object.keys(vehicleDetails || {}).length) {
            return
        }

        const makeOption = commonState?.newMMVlist?.make?.find((v: any) => Number(vehicleDetails?.make) === +v.value)
        const modelOption = commonState?.newMMVlist?.model?.find((v: any) => Number(vehicleDetails?.parent_model_id || vehicleDetails?.model) === +v.value)
        const versionOption = commonState?.newMMVlist?.version?.find((v: any) => Number(vehicleDetails?.version) === +v.value)

        const nextFields: Record<string, any> = {}
        const makeName = getOptionLabel(makeOption) || insuranceState?.leadDetail?.make_name
        const modelName = versionOption?.model_name || vehicleDetails?.parent_model_name || getOptionLabel(modelOption) || insuranceState?.leadDetail?.model_name
        const versionName = getOptionLabel(versionOption) || insuranceState?.leadDetail?.version_name
        const parentModelName = getOptionLabel(modelOption) || insuranceState?.leadDetail?.parent_model_name

        if (vehicleDetails?.make && !vehicleDetails?.make_name && makeName) {
            nextFields.make_name = makeName
        }

        if (vehicleDetails?.model && !vehicleDetails?.model_name && modelName) {
            nextFields.model_name = modelName
        }

        if (vehicleDetails?.version && !vehicleDetails?.version_name && versionName) {
            nextFields.version_name = versionName
        }

        if (vehicleDetails?.parent_model_id && !vehicleDetails?.parent_model_name && parentModelName) {
            nextFields.parent_model_name = parentModelName
        }

        if (Object.keys(nextFields).length) {
            onVehicleDetailsChange({ ...vehicleDetails, ...nextFields }, "vehicle-details")
        }
    }, [
        vehicleDetails,
        insuranceState?.leadDetail?.make_name,
        insuranceState?.leadDetail?.model_name,
        insuranceState?.leadDetail?.version_name,
        insuranceState?.leadDetail?.parent_model_name,
        commonState?.newMMVlist?.make,
        commonState?.newMMVlist?.model,
        commonState?.newMMVlist?.version,
        onVehicleDetailsChange
    ])

    useEffect(() => {
        if (!isCountryId || !vehicleDetails?.plate_no || vehicleDetails?.plate_no === normalizedPlateNo) {
            return
        }

        onVehicleDetailsChange({ ...vehicleDetails, plate_no: normalizedPlateNo }, "vehicle-details")
    }, [
        vehicleDetails,
        vehicleDetails?.plate_no,
        normalizedPlateNo,
        onVehicleDetailsChange
    ])

    return (
        <>
            <div className="">
                <h2>{translations.Insurance?.['Vehicle Details'] || translations.commonMsg?.loading}</h2>
            </div>
            <div className="row">
                {
                    visibleFields?.map((field: any) => {
                        return (
                            <React.Fragment key={field}>
                                {fieldMapping[field]}
                            </React.Fragment>
                        )
                    })
                }
                
                {/* {
                    COUNTRY_CODE !== 'id' && (
                        <>

                        <fieldset className="col-md-6">
                            <div className="material" title={vehicleDetails?.machine_number}>
                                <InputField
                                    inputProps={{
                                        id: "machine_number",
                                        name: "machine_number",
                                        className: "form-input",
                                        type: "text",
                                        value: vehicleDetails.machine_number || '',
                                        maxLength: '',
                                        disabled: false,
                                        placeholder: " "
                                    }}
                                    onChange={(e: any) => changeHandler(e, 'machine_number')}
                                />
                                <label data-label={application_type_id === APP_TYPE_AGENCY ? "Machine Number *" : "Engine Number"} className="form-label"></label>
                                {
                                    errors.machine_number ?
                                        <span className="error-txt">{errors.machine_number}</span>
                                        : ''
                                }
                            </div>
                        </fieldset>
        
                        <fieldset className="col-md-6">
                            <div className="material" title={vehicleDetails?.chassis_number}>
                                <InputField
                                    inputProps={{
                                        id: "chassis_number",
                                        name: "chassis_number",
                                        className: "form-input",
                                        type: "text",
                                        value: vehicleDetails.chassis_number || '',
                                        maxLength: '',
                                        disabled: false,
                                        placeholder: " "
        
                                    }}
                                    onChange={(e: any) => changeHandler(e, 'chassis_number')}
                                />
                                <label data-label={`Chassis Number ${application_type_id === APP_TYPE_AGENCY ? '*' : ''}`} className="form-label"></label>
                                {
                                    errors.chassis_number ?
                                        <span className="error-txt">{errors.chassis_number}</span>
                                        : ''
                                }
                            </div>
                        </fieldset>
        
                        <fieldset className="col-md-6">
                            <div className="material" title={vehicleDetails?.color}>
                                <InputField
                                    inputProps={{
                                        id: "color",
                                        name: "color",
                                        className: "form-input",
                                        type: "text",
                                        value: vehicleDetails.color || '',
                                        maxLength: '',
                                        disabled: false,
                                        placeholder: " "
        
                                    }}
                                    onChange={(e: any) => changeHandler(e, 'color')}
                                />
                                <label data-label={`Color`} className="form-label"></label>
        
                                {
                                    errors.color ?
                                        <span className="error-txt">{errors.color}</span>
                                        : ''
                                }
                            </div>
                        </fieldset>
        
                        <ReactSelect options={commonState?.common?.fuel_type} value={commonState?.common?.fuel_type?.find((v: any) => vehicleDetails?.fuel_type?.toLowerCase() === v?.value?.toLowerCase()) || {}} placeholder={"Fuel Type *"} handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="fuel_type" fieldSetClassName="col-md-6" isDisabled={props.disable} />
        
        
                        <ReactSelect options={commonState?.common?.transmission} value={commonState?.common?.transmission?.find((v: any) => vehicleDetails?.transmission?.toLowerCase() === v?.value?.toLowerCase()) || ''} placeholder={`Transmission`} handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="transmission" fieldSetClassName="col-md-6" isDisabled={props.disable} errorField={errors.transmission}/>
        
        
                        <ReactSelect options={commonState?.common?.seat_capacity} value={commonState?.common?.seat_capacity?.find((v: any) => +vehicleDetails.seat_capacity === +v.value) || {}} placeholder={`Seat Capacity ${application_type_id === APP_TYPE_AGENCY ? '*' : ''}`} handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="seat_capacity" fieldSetClassName="col-md-6" isDisabled={props.disable || [VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(insuranceState?.leadDetail?.vehicle_type) } />
                        </>
                        
                    )

                } */}


            </div>
        </>

    );
}
